import type { FC } from 'react';
import { useCallback } from 'react';
import {
  PapiGallection,
  PapiPremiumFolderData,
  PapiRequestDaSharedGallectionFoldersUpdate,
} from '@wix/da-papi-types';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { putEntities } from '@wix/da-shared-react/pkg/redux/entities/actions';
import { normalizeGallection } from '@wix/da-shared-react/pkg/redux/normalizr/helpers';
import { dollarsToPoints } from '@wix/da-shared-react/pkg/utils/points';
import { updateFolder } from '../../../../actions/studio/folders';
import InlinePriceEdit from '../InlinePriceEdit';

interface Props {
  gallery: PapiGallection;
}

const PremiumGalleryPriceEdit: FC<Props> = ({ gallery }) => {
  const dispatchUpdateFolder = useAction(updateFolder);
  const dispatchPutEntities = useAction(putEntities);
  const onPriceUpdate = useCallback(
    (dollarPrice: number, onSuccess, onError) => {
      const pointsPrice = dollarsToPoints(dollarPrice);
      dispatchUpdateFolder({
        folderId: gallery.folderId,
        data: {
          type: gallery.type as PapiRequestDaSharedGallectionFoldersUpdate['type'],
          premium_type: 'paid',
          points_price: pointsPrice,
        },
        doReload: false,
        onSaveSuccess: () => {
          dispatchPutEntities({
            entities: normalizeGallection({
              ...gallery,
              premiumFolderData: {
                ...gallery.premiumFolderData,
                pointsPrice,
                dollarPrice,
              } as PapiPremiumFolderData,
            }),
          });
          onSuccess();
        },
        onError,
      });
    },
    [gallery, dispatchUpdateFolder, dispatchPutEntities]
  );

  const dollarPrice = gallery.premiumFolderData?.dollarPrice ?? 0;

  return <InlinePriceEdit currentValue={dollarPrice} onSave={onPriceUpdate} />;
};
PremiumGalleryPriceEdit.displayName = 'PremiumGalleryPriceEdit';

export default PremiumGalleryPriceEdit;
